import { render, staticRenderFns } from "./sizetype.vue?vue&type=template&id=b1e7ac3e&"
import script from "./sizetype.vue?vue&type=script&lang=js&"
export * from "./sizetype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports